import { ILanguage } from "./company";

export interface IRepositoryUser {
  key: string;
  name: string;
  order: number;
  IsPresentation: boolean;
  folderId: number;
  presentationId: number;
  children: IRepositoryUser[];
  hasContent: boolean;
}

export interface ContentDataPresentationPlayer {
  original: string;
  thumbnail: string;
  totalNumber: number;
  index: number;
  isVideo: boolean;
  fileId:number;
}



export interface IPresentationDetail {
  // id:number;
  mainLanguageId: string;
  presentationLanguages: IPresentationLanguage[];
}

export interface IPresentationLanguage {
  id: number;
  languageId: number;
  title: string;
  contentId?: number;
  isMain?: boolean;
  attachedFiles?: FileList;
}
export class PresentationDetailsFormValues implements IPresentationDetail {
  mainLanguageId: string = "";
  languages: ILanguage[] = [];
  presentationLanguages: IPresentationLanguage[] = [];
  id: number = 0;
  selectedLanguages: number[] = [];
  constructor(init?: PresentationDetailsFormValues) {
    Object.assign(this, init);
  }
}

export class PresentationLanguagesFormValues implements IPresentationLanguage {
  id: number = 0;
  languageId: number = 0;
  title: string = "";
  contentId?: number | undefined;
  isMain: boolean = false;
  attachedFiles?: FileList | undefined;
  constructor(init?: IPresentationLanguage) {
    Object.assign(this, init);
  }
}

export interface IPresentationEditPageDto {
 
  languages: ILanguage[],
  presentation:IPresentationDetail;
  canManagePodium: boolean
    
}

export interface IResultUploadFilesDto{
  result: number;
  title: string;
  code: string;
  errorfiles: string[];
  insertedContentsIds? : number[];
  completedPercentage? : number;
  folderSizeFull ?: boolean;
}


export interface IDiskUser {

  avaibleDiskSpace: number,
  currentDiskSpace: number,
  canUploadFile: number,
}

